module.exports = __webpack_public_path__ + "assets/img/titel.78def293.jpg";